import {
  CONTRACT_AUTHENTICATION_INITIALIZE,
  PARTICIPANT_STATUS_FAILURE,
} from '@app/store/actionTypes';
import { ContractAuthenticationAction } from '@app/store/contract-authentication/actions';

import {
  fetchParticipantStatus,
  fetchParticipantStatusAfterLoginWithToken,
  fetchParticipantStatusSuccess,
  ParticipantAction,
} from '../actions';

type IsFetchingState = boolean;

const initialState: IsFetchingState = false;

export default function reducer(
  state: IsFetchingState = initialState,
  action: ParticipantAction | ContractAuthenticationAction
) {
  switch (action.type) {
    case CONTRACT_AUTHENTICATION_INITIALIZE:
      return initialState;
    case fetchParticipantStatusAfterLoginWithToken.type:
    case fetchParticipantStatus.type:
      return true;
    case fetchParticipantStatusSuccess.type:
      return false;
    case PARTICIPANT_STATUS_FAILURE:
      return false;
    default:
      return state;
  }
}
